import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateInspecaoMaquinasEquipDetailUseCase } from "../../../presentation/useCases/update/update_inspecao_maquinas_equip_detail_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateInspecaoMaquinasEquipDetailUseCase
 */

export class UpdateInspecaoMaquinasEquipDetailUseCase implements IUpdateInspecaoMaquinasEquipDetailUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateInspecaoMaquinasEquipDetail(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    idFuncionarioInspecionado: number | null,
    idFuncionarioAprovado: number | null,
    status: number | null,
    dataEncerramento: Date | null,
    descricaoProblema: string | null,
    correcaoProblema: string | null,
    arquivo1: File | null,
    arquivo2: File | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    itens: {
      idInspecaoMaquinaEquipItens: number;
      ordem: number;
      descricao: string;
      inspecao1: string;
      inspecao2: string;
    }[] | null,
  ): Promise<void> {
    const arquivo1Nome = await this.getFilename(arquivo1);
    const arquivo2Nome = await this.getFilename(arquivo2);

    const arquivo1Data = await this.convertToBase64(arquivo1);
    const arquivo2Data = await this.convertToBase64(arquivo2);

    const itensToUpdate = itens !== null
      ? itens.map(item => ({
        idInspecaoMaquinaEquipItens: item.idInspecaoMaquinaEquipItens,
        inspecao1: item.inspecao1,
        inspecao2: item.inspecao2,
      }))
      : null;

    await this.repository.updateInspecaoMaquinasEquipDetail(
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      idFuncionarioInspecionado,
      idFuncionarioAprovado,
      status ?? 0,
      dataEncerramento,
      descricaoProblema,
      correcaoProblema,
      arquivo1Nome,
      arquivo1Data,
      arquivo2Nome,
      arquivo2Data,
      limparArquivo1,
      limparArquivo2,
      itensToUpdate,
    );
  }



  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }

  private async convertToBase64(file: File | null): Promise<string | null> {
    return await FileUtils.readFileAsBase64(file);
  }
}
